export default "__VITE_PUBLIC_ASSET__39b828d0__"